







































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import SearchFilterDatepicker from "@/views/search/search-filter-datepicker.vue";
import { UserModule } from "@/store/modules/User";
import { QueryObject } from "@/views/search/search.vue";
import { CustomerType } from "@/models/CustomerModel";
import { SearchRequest } from "@/views/search/searchRequest";
import Person from "@/components/icons/person.vue";

@Component({
    components: { SearchFilterDatepicker, Person }
})
export default class SearchFilterComponent extends Vue {
    user = UserModule;
    caseStatuses: CaseStatus[] = [];
    filterToShow = "";
    isSmall = true;

    @Prop(Object)
    query!: QueryObject;

    @Prop(Array)
    internalInclude!: string[];

    @Prop(Array)
    searchRequests!: SearchRequest[];

    @Prop(Boolean)
    isAnyFilterActive!: boolean;

     @Prop(Boolean)
    openFilterMenu!: boolean;

    @Prop({ type: Boolean, default: false })
    isFilterDisabled!: boolean;

    get isFilterButtonDisabled() {
        return !this.isAnyFilterActive && this.internalInclude.length === this.searchRequests.length;
    }

    get allSystemsChecked() {
        return !this.query.system.length;
    }

    set allSystemsChecked(value: boolean) {
        if (this.query.system.length) {
            this.query.system = [];
        }
    }

    get allCaseStatusChecked() {
        return !this.query.caseStatus.length;
    }

    set allCaseStatusChecked(value: boolean) {
        if (this.query.caseStatus.length) {
            this.query.caseStatus = [];
        }
    }

    get allCaseStateChecked() {
        return !this.query.caseState.length;
    }

    set allCaseStateChecked(value: boolean) {
        if (this.query.caseState.length) {
            this.query.caseState = [];
        }
    }

    get customerTypeConsumer() {
        return this.query.customerType?.includes(CustomerType.PERSON.toString());
    }

    set customerTypeConsumer(value: boolean) {
        if (value) {
            this.query.customerType = [...this.query.customerType, CustomerType.PERSON.toString()];
        } else {
            this.query.customerType = this.query.customerType.filter(customerType => customerType !== CustomerType.PERSON.toString());
        }
    }

    get customerTypeCompany() {
        return this.query.customerType?.includes(CustomerType.COMPANY.toString()) && this.query.customerType.includes(CustomerType.PRIVATEFIRM.toString());
    }

    set customerTypeCompany(value: boolean) {
        if (value) {
            this.query.customerType = [
                ...this.query.customerType,
                CustomerType.COMPANY.toString(),
                CustomerType.PRIVATEFIRM.toString()
            ];
        } else {
            this.query.customerType = this.query.customerType.filter(customerType => {
                return customerType !== CustomerType.COMPANY.toString() && customerType !== CustomerType.PRIVATEFIRM.toString();
            });
        }
    }

    get statusTranslations() {
        return { ...UserModule.externalTranslations.STATUS };
    }

    get internalCaseStatus() {
        return this.caseStatuses.filter(status => this.query.caseStatus.includes(status.generalCode));
    }

    set internalCaseStatus(statuses: CaseStatus[]) {
        const newCaseStatus = statuses.map(status => status.generalCode);

        if (Object.entries(newCaseStatus).toString() === Object.entries(this.query.caseStatus).toString()) {
            return; // Prevent unnecessary navigation change
        }

        this.query.caseStatus = newCaseStatus;
    }

    get internalCountries() {
        return this.user.systemCountries.filter(country => this.query.system.includes(country.countryId.toString()));
    }

    set internalCountries(countries) {
        const countryIds = countries.map(country => country.countryId.toString());
        this.query.system = countryIds;
    }

    get caseState(): CaseState[] {
        return [
            { name: this.$t("caseState.1") as string, value: 1 },
            { name: this.$t("caseState.2") as string, value: 2 },
            { name: this.$t("caseState.3") as string, value: 3 }
        ];
    }

    get internalCaseState() {
        return this.caseState.filter(state => this.query.caseState.includes(state.value.toString()));
    }

    set internalCaseState(caseState) {
        const caseStateValues = caseState.map(state => state.value.toString());
        this.query.caseState = caseStateValues;
    }

    get caseTypes() {
        return this.searchRequests.filter(search => this.internalInclude.includes(search.name));
    }

    get theme() {
        return UserModule.theme;
    }

    @Watch("statusTranslations", { immediate: true })
    onStatusTranslationsChange(translations: { [key: string]: string }) {
        if (!Object.entries(translations).length) {
            return;
        }

        this.caseStatuses = Object.entries(translations).map(([key, value]) => {
            return { generalCode: key, translation: value };
        });

        this.internalCaseStatus = this.caseStatuses.filter(status => this.query.caseStatus.includes(status.generalCode));
    }

    shouldShowGeneralCode(translation: string) {
        return this.caseStatuses.filter(status => status.translation === translation).length > 1;
    }

    onCaseTypeChange(caseTypes: string[]) {
        this.$emit("on-case-type-change", caseTypes);
    }

    clearCaseRegDates() {
        this.query.caseRegDateMin = "";
        this.query.caseRegDateMax = "";
    }

    clearCaseClosedDates() {
        this.query.caseCloseDateMin = "";
        this.query.caseCloseDateMax = "";
    }

    clearFilters() {
        this.$emit("clear-filters");
    }

    resetResultTypeFilter() {
        this.query.include = [];
    }

    resetCountryFilter () {
        this.query.system = [];
    }

    resetDebtorFilter () {
        this.query.customerType = [];
    }

    resetCaseStatusFilter () {
        this.query.caseStatus = [];
    }

    resetCaseStateFilter () {
        this.query.caseState = [];
    }

    closeMenu() {
        this.$emit("close-menu");
    }
}

interface CaseStatus {
    generalCode: string;
    translation: string;
}

interface CaseState {
    name: string;
    value: number;
}
